import { Context } from "csi/def/Context";
import Heading from "csi/def/Heading";
import Enum from "csi/heading/Enum";
import TextWithMaterialIcon from "csi/widget/TextWithMaterialIcon";
import xml from "csi/xml";
import declare from "dojo/_base/declare";
import { getIconParameters } from "./ProofService";

const TaskStatusRenderer = declare(Enum, {
	/**
	 * @override
	 * Add icon before the text
	 */
	toHtmlStatic(ctx: Context, h: Heading, refNode: Element, _params) {
		const enumValue = this._getValue(ctx, h);
		const value = xml.enumGetText(enumValue);

		// Do not render if value is not yet defined
		if (!value) {
			return true;
		}
		const text = this.toValue(ctx, h);
		new TextWithMaterialIcon(getIconParameters(value, false, true, text))
			.placeAt(refNode);
		return true;
	},
});

export = TaskStatusRenderer;